export const questionMapping = {
    'ai-workshop-mar-2025-london': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        }
    },
    'lcc-june-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        }
    },
    'bcc-june-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        }
    },
    'ai-transform-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        }
    },
    'your-future-digial-workshop-london-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        }
    },
    'ideas-fest-uk-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        }
    },
    'your-future-digial-workshop-manchester-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        },
        '3d-growth-system': {
            tabName: 'The 3D Growth System',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Quick Check: Your Hidden Opportunities',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Which apply to your business? (tick all that apply)',
                            answerKey: '3d-growth-system-q-0-0',
                            questionType: 'checkbox',
                            options: [
                                'Database of "old" contacts not touched in months',
                                'Weekend enquiries wait until Monday for response',
                                'Support team answers same questions repeatedly',
                                'Customer Success Managers too busy to be proactive',
                                'Every customer gets same generic experience',
                                'Discover customer churn after it\'s too late'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Part 1: Revenue Dimension - Lead Response Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Enquiries per month:',
                            answerKey: '3d-growth-system-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: '% of enquiries outside office hours:',
                            answerKey: '3d-growth-system-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current response time to these:',
                            answerKey: '3d-growth-system-q-1-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: '% contacted within 1 hour:',
                            answerKey: '3d-growth-system-q-1-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: '% contacted after 24 hours:',
                            answerKey: '3d-growth-system-q-1-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If you contacted 100% within 5 minutes, how many more would convert?',
                            answerKey: '3d-growth-system-q-1-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Weekend revenue currently lost: £',
                            answerKey: '3d-growth-system-q-1-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Part 1: Revenue Dimension - Database Mining Potential',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Total contacts in database:',
                            answerKey: '3d-growth-system-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Contacted in last 6 months:',
                            answerKey: '3d-growth-system-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Estimated % who might now be ready:',
                            answerKey: '3d-growth-system-q-2-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Hidden revenue in dormant database: £',
                            answerKey: '3d-growth-system-q-2-4'
                        }
                    ]
                },
                {
                    exerciseNumber: 4,
                    exerciseName: 'Part 2: Capacity Dimension - Support Efficiency Audit',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Support tickets per month:',
                            answerKey: '3d-growth-system-q-3-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: '% that are repeat questions:',
                            answerKey: '3d-growth-system-q-3-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Time spent weekly on answering repetitive questions:',
                            answerKey: '3d-growth-system-q-3-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Time spent weekly on manual ticket routing:',
                            answerKey: '3d-growth-system-q-3-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Time spent weekly on writing similar responses:',
                            answerKey: '3d-growth-system-q-3-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Time spent weekly on after-hours coverage:',
                            answerKey: '3d-growth-system-q-3-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Total time that could be redirected:',
                            answerKey: '3d-growth-system-q-3-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 5,
                    exerciseName: 'Part 2: Capacity Dimension - Customer Success Scale',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Customers per Success Manager:',
                            answerKey: '3d-growth-system-q-4-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average upsell value: £',
                            answerKey: '3d-growth-system-q-4-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Customer lifetime value: £',
                            answerKey: '3d-growth-system-q-4-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current monthly churn rate:',
                            answerKey: '3d-growth-system-q-4-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Proactive check-ins per month:',
                            answerKey: '3d-growth-system-q-4-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'If CSMs had 50% more time - Additional customers saved/month:',
                            answerKey: '3d-growth-system-q-4-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If CSMs had 50% more time - Additional upsell conversations:',
                            answerKey: '3d-growth-system-q-4-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Revenue protected/expanded with more capacity: £',
                            answerKey: '3d-growth-system-q-4-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 6,
                    exerciseName: 'Part 3: Experience Dimension - Personalisation Assessment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: '% getting generic experience:',
                            answerKey: '3d-growth-system-q-5-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average products/services per customer:',
                            answerKey: '3d-growth-system-q-5-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Cross-sell conversion rate:',
                            answerKey: '3d-growth-system-q-5-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Could personalisation increase spend per customer?',
                            answerKey: '3d-growth-system-q-5-3',
                            questionType: 'radio',
                            options: [
                                'Definitely (20-40% typical)',
                                'Probably (10-20% typical)',
                                'Possibly (5-10% typical)',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Example for your business: What journey would delight your best customer segment?',
                            answerKey: '3d-growth-system-q-5-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Additional revenue per customer with personalisation: £',
                            answerKey: '3d-growth-system-q-5-5'
                        }
                    ]
                },
                {
                    exerciseNumber: 7,
                    exerciseName: 'Part 4: Priority & Impact - Your Opportunity Matrix',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Rate Weekend response (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Rate Weekend response (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Rate Database reactivation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Rate Database reactivation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Rate Support automation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Rate Support automation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Rate Success scaling (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Rate Success scaling (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-7'
                        },
                        {
                            questionNumber: 8,
                            questionText: 'Rate Personalisation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-8'
                        },
                        {
                            questionNumber: 9,
                            questionText: 'Rate Personalisation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-9'
                        },
                        {
                            questionNumber: 10,
                            questionText: 'Your #1 Opportunity:',
                            answerKey: '3d-growth-system-q-6-10'
                        }
                    ]
                },
                {
                    exerciseNumber: 8,
                    exerciseName: 'Part 4: Priority & Impact - Deep Dive: Your Biggest Win',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'What\'s broken today:',
                            answerKey: '3d-growth-system-q-7-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Hours wasted weekly:',
                            answerKey: '3d-growth-system-q-7-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Revenue lost monthly: £',
                            answerKey: '3d-growth-system-q-7-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What success looks like:',
                            answerKey: '3d-growth-system-q-7-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Month 1 impact: £',
                            answerKey: '3d-growth-system-q-7-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Month 6 impact: £',
                            answerKey: '3d-growth-system-q-7-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Year 1 impact: £',
                            answerKey: '3d-growth-system-q-7-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 9,
                    exerciseName: 'Part 5: Making It Happen - Reality Check',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Are competitors doing this?',
                            answerKey: '3d-growth-system-q-8-0',
                            questionType: 'radio',
                            options: [
                                'Yes',
                                'No',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Why haven\'t you done it yet?',
                            answerKey: '3d-growth-system-q-8-1',
                            questionType: 'checkbox',
                            options: [
                                'Didn\'t know it was possible',
                                'No time to implement',
                                'Unclear on ROI',
                                'Technology barriers',
                                'Team resistance'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What\'s the cost of waiting another month? £',
                            answerKey: '3d-growth-system-q-8-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 10,
                    exerciseName: 'Part 5: Making It Happen - Your Readiness',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'When do you want this fixed?',
                            answerKey: '3d-growth-system-q-9-0',
                            questionType: 'radio',
                            options: [
                                'This month - urgent priority',
                                'This quarter - active project',
                                'This year - planning stage',
                                'Just exploring options'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'What would help you most?',
                            answerKey: '3d-growth-system-q-9-1',
                            questionType: 'checkbox',
                            options: [
                                'See exactly how it works',
                                'Understand the ROI clearly',
                                'Get team buy-in',
                                'Start with small pilot',
                                'Full implementation plan'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Preferred next step:',
                            answerKey: '3d-growth-system-q-9-2',
                            questionType: 'radio',
                            options: [
                                'Meeting to discuss',
                                'Not ready yet'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 11,
                    exerciseName: 'Part 5: Making It Happen - Your Commitment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'The ONE opportunity I will pursue:',
                            answerKey: '3d-growth-system-q-10-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Revenue I will capture: £',
                            answerKey: '3d-growth-system-q-10-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'By when:',
                            answerKey: '3d-growth-system-q-10-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Tomorrow I will:',
                            answerKey: '3d-growth-system-q-10-3'
                        }
                    ]
                }
            ]
        }
    },
    'festival-of-entrpreneurs-2025': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        },
        '3d-growth-system': {
            tabName: 'The 3D Growth System',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Quick Check: Your Hidden Opportunities',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Which apply to your business? (tick all that apply)',
                            answerKey: '3d-growth-system-q-0-0',
                            questionType: 'checkbox',
                            options: [
                                'Database of "old" contacts not touched in months',
                                'Weekend enquiries wait until Monday for response',
                                'Support team answers same questions repeatedly',
                                'Customer Success Managers too busy to be proactive',
                                'Every customer gets same generic experience',
                                'Discover customer churn after it\'s too late'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Part 1: Revenue Dimension - Lead Response Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Enquiries per month:',
                            answerKey: '3d-growth-system-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: '% of enquiries outside office hours:',
                            answerKey: '3d-growth-system-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current response time to these:',
                            answerKey: '3d-growth-system-q-1-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: '% contacted within 1 hour:',
                            answerKey: '3d-growth-system-q-1-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: '% contacted after 24 hours:',
                            answerKey: '3d-growth-system-q-1-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If you contacted 100% within 5 minutes, how many more would convert?',
                            answerKey: '3d-growth-system-q-1-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Weekend revenue currently lost: £',
                            answerKey: '3d-growth-system-q-1-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Part 1: Revenue Dimension - Database Mining Potential',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Total contacts in database:',
                            answerKey: '3d-growth-system-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Contacted in last 6 months:',
                            answerKey: '3d-growth-system-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Estimated % who might now be ready:',
                            answerKey: '3d-growth-system-q-2-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Hidden revenue in dormant database: £',
                            answerKey: '3d-growth-system-q-2-4'
                        }
                    ]
                },
                {
                    exerciseNumber: 4,
                    exerciseName: 'Part 2: Capacity Dimension - Support Efficiency Audit',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Support tickets per month:',
                            answerKey: '3d-growth-system-q-3-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: '% that are repeat questions:',
                            answerKey: '3d-growth-system-q-3-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Time spent weekly on answering repetitive questions:',
                            answerKey: '3d-growth-system-q-3-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Time spent weekly on manual ticket routing:',
                            answerKey: '3d-growth-system-q-3-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Time spent weekly on writing similar responses:',
                            answerKey: '3d-growth-system-q-3-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Time spent weekly on after-hours coverage:',
                            answerKey: '3d-growth-system-q-3-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Total time that could be redirected:',
                            answerKey: '3d-growth-system-q-3-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 5,
                    exerciseName: 'Part 2: Capacity Dimension - Customer Success Scale',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Customers per Success Manager:',
                            answerKey: '3d-growth-system-q-4-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average upsell value: £',
                            answerKey: '3d-growth-system-q-4-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Customer lifetime value: £',
                            answerKey: '3d-growth-system-q-4-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current monthly churn rate:',
                            answerKey: '3d-growth-system-q-4-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Proactive check-ins per month:',
                            answerKey: '3d-growth-system-q-4-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'If CSMs had 50% more time - Additional customers saved/month:',
                            answerKey: '3d-growth-system-q-4-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If CSMs had 50% more time - Additional upsell conversations:',
                            answerKey: '3d-growth-system-q-4-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Revenue protected/expanded with more capacity: £',
                            answerKey: '3d-growth-system-q-4-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 6,
                    exerciseName: 'Part 3: Experience Dimension - Personalisation Assessment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: '% getting generic experience:',
                            answerKey: '3d-growth-system-q-5-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average products/services per customer:',
                            answerKey: '3d-growth-system-q-5-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Cross-sell conversion rate:',
                            answerKey: '3d-growth-system-q-5-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Could personalisation increase spend per customer?',
                            answerKey: '3d-growth-system-q-5-3',
                            questionType: 'radio',
                            options: [
                                'Definitely (20-40% typical)',
                                'Probably (10-20% typical)',
                                'Possibly (5-10% typical)',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Example for your business: What journey would delight your best customer segment?',
                            answerKey: '3d-growth-system-q-5-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Additional revenue per customer with personalisation: £',
                            answerKey: '3d-growth-system-q-5-5'
                        }
                    ]
                },
                {
                    exerciseNumber: 7,
                    exerciseName: 'Part 4: Priority & Impact - Your Opportunity Matrix',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Rate Weekend response (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Rate Weekend response (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Rate Database reactivation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Rate Database reactivation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Rate Support automation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Rate Support automation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Rate Success scaling (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Rate Success scaling (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-7'
                        },
                        {
                            questionNumber: 8,
                            questionText: 'Rate Personalisation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-8'
                        },
                        {
                            questionNumber: 9,
                            questionText: 'Rate Personalisation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-9'
                        },
                        {
                            questionNumber: 10,
                            questionText: 'Your #1 Opportunity:',
                            answerKey: '3d-growth-system-q-6-10'
                        }
                    ]
                },
                {
                    exerciseNumber: 8,
                    exerciseName: 'Part 4: Priority & Impact - Deep Dive: Your Biggest Win',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'What\'s broken today:',
                            answerKey: '3d-growth-system-q-7-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Hours wasted weekly:',
                            answerKey: '3d-growth-system-q-7-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Revenue lost monthly: £',
                            answerKey: '3d-growth-system-q-7-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What success looks like:',
                            answerKey: '3d-growth-system-q-7-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Month 1 impact: £',
                            answerKey: '3d-growth-system-q-7-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Month 6 impact: £',
                            answerKey: '3d-growth-system-q-7-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Year 1 impact: £',
                            answerKey: '3d-growth-system-q-7-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 9,
                    exerciseName: 'Part 5: Making It Happen - Reality Check',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Are competitors doing this?',
                            answerKey: '3d-growth-system-q-8-0',
                            questionType: 'radio',
                            options: [
                                'Yes',
                                'No',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Why haven\'t you done it yet?',
                            answerKey: '3d-growth-system-q-8-1',
                            questionType: 'checkbox',
                            options: [
                                'Didn\'t know it was possible',
                                'No time to implement',
                                'Unclear on ROI',
                                'Technology barriers',
                                'Team resistance'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What\'s the cost of waiting another month? £',
                            answerKey: '3d-growth-system-q-8-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 10,
                    exerciseName: 'Part 5: Making It Happen - Your Readiness',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'When do you want this fixed?',
                            answerKey: '3d-growth-system-q-9-0',
                            questionType: 'radio',
                            options: [
                                'This month - urgent priority',
                                'This quarter - active project',
                                'This year - planning stage',
                                'Just exploring options'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'What would help you most?',
                            answerKey: '3d-growth-system-q-9-1',
                            questionType: 'checkbox',
                            options: [
                                'See exactly how it works',
                                'Understand the ROI clearly',
                                'Get team buy-in',
                                'Start with small pilot',
                                'Full implementation plan'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Preferred next step:',
                            answerKey: '3d-growth-system-q-9-2',
                            questionType: 'radio',
                            options: [
                                'Meeting to discuss',
                                'Not ready yet'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 11,
                    exerciseName: 'Part 5: Making It Happen - Your Commitment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'The ONE opportunity I will pursue:',
                            answerKey: '3d-growth-system-q-10-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Revenue I will capture: £',
                            answerKey: '3d-growth-system-q-10-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'By when:',
                            answerKey: '3d-growth-system-q-10-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Tomorrow I will:',
                            answerKey: '3d-growth-system-q-10-3'
                        }
                    ]
                }
            ]
        }
    },
    'your-future-digial-workshop-london-2026': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        },
        '3d-growth-system': {
            tabName: 'The 3D Growth System',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Quick Check: Your Hidden Opportunities',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Which apply to your business? (tick all that apply)',
                            answerKey: '3d-growth-system-q-0-0',
                            questionType: 'checkbox',
                            options: [
                                'Database of "old" contacts not touched in months',
                                'Weekend enquiries wait until Monday for response',
                                'Support team answers same questions repeatedly',
                                'Customer Success Managers too busy to be proactive',
                                'Every customer gets same generic experience',
                                'Discover customer churn after it\'s too late'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Part 1: Revenue Dimension - Lead Response Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Enquiries per month:',
                            answerKey: '3d-growth-system-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: '% of enquiries outside office hours:',
                            answerKey: '3d-growth-system-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current response time to these:',
                            answerKey: '3d-growth-system-q-1-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: '% contacted within 1 hour:',
                            answerKey: '3d-growth-system-q-1-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: '% contacted after 24 hours:',
                            answerKey: '3d-growth-system-q-1-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If you contacted 100% within 5 minutes, how many more would convert?',
                            answerKey: '3d-growth-system-q-1-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Weekend revenue currently lost: £',
                            answerKey: '3d-growth-system-q-1-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Part 1: Revenue Dimension - Database Mining Potential',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Total contacts in database:',
                            answerKey: '3d-growth-system-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Contacted in last 6 months:',
                            answerKey: '3d-growth-system-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Estimated % who might now be ready:',
                            answerKey: '3d-growth-system-q-2-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Hidden revenue in dormant database: £',
                            answerKey: '3d-growth-system-q-2-4'
                        }
                    ]
                },
                {
                    exerciseNumber: 4,
                    exerciseName: 'Part 2: Capacity Dimension - Support Efficiency Audit',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Support tickets per month:',
                            answerKey: '3d-growth-system-q-3-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: '% that are repeat questions:',
                            answerKey: '3d-growth-system-q-3-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Time spent weekly on answering repetitive questions:',
                            answerKey: '3d-growth-system-q-3-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Time spent weekly on manual ticket routing:',
                            answerKey: '3d-growth-system-q-3-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Time spent weekly on writing similar responses:',
                            answerKey: '3d-growth-system-q-3-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Time spent weekly on after-hours coverage:',
                            answerKey: '3d-growth-system-q-3-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Total time that could be redirected:',
                            answerKey: '3d-growth-system-q-3-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 5,
                    exerciseName: 'Part 2: Capacity Dimension - Customer Success Scale',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Customers per Success Manager:',
                            answerKey: '3d-growth-system-q-4-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average upsell value: £',
                            answerKey: '3d-growth-system-q-4-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Customer lifetime value: £',
                            answerKey: '3d-growth-system-q-4-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current monthly churn rate:',
                            answerKey: '3d-growth-system-q-4-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Proactive check-ins per month:',
                            answerKey: '3d-growth-system-q-4-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'If CSMs had 50% more time - Additional customers saved/month:',
                            answerKey: '3d-growth-system-q-4-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If CSMs had 50% more time - Additional upsell conversations:',
                            answerKey: '3d-growth-system-q-4-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Revenue protected/expanded with more capacity: £',
                            answerKey: '3d-growth-system-q-4-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 6,
                    exerciseName: 'Part 3: Experience Dimension - Personalisation Assessment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: '% getting generic experience:',
                            answerKey: '3d-growth-system-q-5-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average products/services per customer:',
                            answerKey: '3d-growth-system-q-5-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Cross-sell conversion rate:',
                            answerKey: '3d-growth-system-q-5-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Could personalisation increase spend per customer?',
                            answerKey: '3d-growth-system-q-5-3',
                            questionType: 'radio',
                            options: [
                                'Definitely (20-40% typical)',
                                'Probably (10-20% typical)',
                                'Possibly (5-10% typical)',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Example for your business: What journey would delight your best customer segment?',
                            answerKey: '3d-growth-system-q-5-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Additional revenue per customer with personalisation: £',
                            answerKey: '3d-growth-system-q-5-5'
                        }
                    ]
                },
                {
                    exerciseNumber: 7,
                    exerciseName: 'Part 4: Priority & Impact - Your Opportunity Matrix',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Rate Weekend response (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Rate Weekend response (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Rate Database reactivation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Rate Database reactivation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Rate Support automation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Rate Support automation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Rate Success scaling (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Rate Success scaling (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-7'
                        },
                        {
                            questionNumber: 8,
                            questionText: 'Rate Personalisation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-8'
                        },
                        {
                            questionNumber: 9,
                            questionText: 'Rate Personalisation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-9'
                        },
                        {
                            questionNumber: 10,
                            questionText: 'Your #1 Opportunity:',
                            answerKey: '3d-growth-system-q-6-10'
                        }
                    ]
                },
                {
                    exerciseNumber: 8,
                    exerciseName: 'Part 4: Priority & Impact - Deep Dive: Your Biggest Win',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'What\'s broken today:',
                            answerKey: '3d-growth-system-q-7-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Hours wasted weekly:',
                            answerKey: '3d-growth-system-q-7-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Revenue lost monthly: £',
                            answerKey: '3d-growth-system-q-7-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What success looks like:',
                            answerKey: '3d-growth-system-q-7-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Month 1 impact: £',
                            answerKey: '3d-growth-system-q-7-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Month 6 impact: £',
                            answerKey: '3d-growth-system-q-7-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Year 1 impact: £',
                            answerKey: '3d-growth-system-q-7-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 9,
                    exerciseName: 'Part 5: Making It Happen - Reality Check',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Are competitors doing this?',
                            answerKey: '3d-growth-system-q-8-0',
                            questionType: 'radio',
                            options: [
                                'Yes',
                                'No',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Why haven\'t you done it yet?',
                            answerKey: '3d-growth-system-q-8-1',
                            questionType: 'checkbox',
                            options: [
                                'Didn\'t know it was possible',
                                'No time to implement',
                                'Unclear on ROI',
                                'Technology barriers',
                                'Team resistance'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What\'s the cost of waiting another month? £',
                            answerKey: '3d-growth-system-q-8-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 10,
                    exerciseName: 'Part 5: Making It Happen - Your Readiness',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'When do you want this fixed?',
                            answerKey: '3d-growth-system-q-9-0',
                            questionType: 'radio',
                            options: [
                                'This month - urgent priority',
                                'This quarter - active project',
                                'This year - planning stage',
                                'Just exploring options'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'What would help you most?',
                            answerKey: '3d-growth-system-q-9-1',
                            questionType: 'checkbox',
                            options: [
                                'See exactly how it works',
                                'Understand the ROI clearly',
                                'Get team buy-in',
                                'Start with small pilot',
                                'Full implementation plan'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Preferred next step:',
                            answerKey: '3d-growth-system-q-9-2',
                            questionType: 'radio',
                            options: [
                                'Meeting to discuss',
                                'Not ready yet'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 11,
                    exerciseName: 'Part 5: Making It Happen - Your Commitment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'The ONE opportunity I will pursue:',
                            answerKey: '3d-growth-system-q-10-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Revenue I will capture: £',
                            answerKey: '3d-growth-system-q-10-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'By when:',
                            answerKey: '3d-growth-system-q-10-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Tomorrow I will:',
                            answerKey: '3d-growth-system-q-10-3'
                        }
                    ]
                }
            ]
        }
    },
    'your-future-digial-workshop-dubai-2026': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        },
        '3d-growth-system': {
            tabName: 'The 3D Growth System',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Quick Check: Your Hidden Opportunities',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Which apply to your business? (tick all that apply)',
                            answerKey: '3d-growth-system-q-0-0',
                            questionType: 'checkbox',
                            options: [
                                'Database of "old" contacts not touched in months',
                                'Weekend enquiries wait until Monday for response',
                                'Support team answers same questions repeatedly',
                                'Customer Success Managers too busy to be proactive',
                                'Every customer gets same generic experience',
                                'Discover customer churn after it\'s too late'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Part 1: Revenue Dimension - Lead Response Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Enquiries per month:',
                            answerKey: '3d-growth-system-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: '% of enquiries outside office hours:',
                            answerKey: '3d-growth-system-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current response time to these:',
                            answerKey: '3d-growth-system-q-1-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: '% contacted within 1 hour:',
                            answerKey: '3d-growth-system-q-1-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: '% contacted after 24 hours:',
                            answerKey: '3d-growth-system-q-1-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If you contacted 100% within 5 minutes, how many more would convert?',
                            answerKey: '3d-growth-system-q-1-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Weekend revenue currently lost: £',
                            answerKey: '3d-growth-system-q-1-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Part 1: Revenue Dimension - Database Mining Potential',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Total contacts in database:',
                            answerKey: '3d-growth-system-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Contacted in last 6 months:',
                            answerKey: '3d-growth-system-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Estimated % who might now be ready:',
                            answerKey: '3d-growth-system-q-2-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Hidden revenue in dormant database: £',
                            answerKey: '3d-growth-system-q-2-4'
                        }
                    ]
                },
                {
                    exerciseNumber: 4,
                    exerciseName: 'Part 2: Capacity Dimension - Support Efficiency Audit',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Support tickets per month:',
                            answerKey: '3d-growth-system-q-3-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: '% that are repeat questions:',
                            answerKey: '3d-growth-system-q-3-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Time spent weekly on answering repetitive questions:',
                            answerKey: '3d-growth-system-q-3-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Time spent weekly on manual ticket routing:',
                            answerKey: '3d-growth-system-q-3-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Time spent weekly on writing similar responses:',
                            answerKey: '3d-growth-system-q-3-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Time spent weekly on after-hours coverage:',
                            answerKey: '3d-growth-system-q-3-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Total time that could be redirected:',
                            answerKey: '3d-growth-system-q-3-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 5,
                    exerciseName: 'Part 2: Capacity Dimension - Customer Success Scale',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Customers per Success Manager:',
                            answerKey: '3d-growth-system-q-4-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average upsell value: £',
                            answerKey: '3d-growth-system-q-4-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Customer lifetime value: £',
                            answerKey: '3d-growth-system-q-4-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current monthly churn rate:',
                            answerKey: '3d-growth-system-q-4-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Proactive check-ins per month:',
                            answerKey: '3d-growth-system-q-4-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'If CSMs had 50% more time - Additional customers saved/month:',
                            answerKey: '3d-growth-system-q-4-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If CSMs had 50% more time - Additional upsell conversations:',
                            answerKey: '3d-growth-system-q-4-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Revenue protected/expanded with more capacity: £',
                            answerKey: '3d-growth-system-q-4-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 6,
                    exerciseName: 'Part 3: Experience Dimension - Personalisation Assessment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: '% getting generic experience:',
                            answerKey: '3d-growth-system-q-5-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average products/services per customer:',
                            answerKey: '3d-growth-system-q-5-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Cross-sell conversion rate:',
                            answerKey: '3d-growth-system-q-5-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Could personalisation increase spend per customer?',
                            answerKey: '3d-growth-system-q-5-3',
                            questionType: 'radio',
                            options: [
                                'Definitely (20-40% typical)',
                                'Probably (10-20% typical)',
                                'Possibly (5-10% typical)',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Example for your business: What journey would delight your best customer segment?',
                            answerKey: '3d-growth-system-q-5-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Additional revenue per customer with personalisation: £',
                            answerKey: '3d-growth-system-q-5-5'
                        }
                    ]
                },
                {
                    exerciseNumber: 7,
                    exerciseName: 'Part 4: Priority & Impact - Your Opportunity Matrix',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Rate Weekend response (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Rate Weekend response (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Rate Database reactivation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Rate Database reactivation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Rate Support automation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Rate Support automation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Rate Success scaling (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Rate Success scaling (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-7'
                        },
                        {
                            questionNumber: 8,
                            questionText: 'Rate Personalisation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-8'
                        },
                        {
                            questionNumber: 9,
                            questionText: 'Rate Personalisation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-9'
                        },
                        {
                            questionNumber: 10,
                            questionText: 'Your #1 Opportunity:',
                            answerKey: '3d-growth-system-q-6-10'
                        }
                    ]
                },
                {
                    exerciseNumber: 8,
                    exerciseName: 'Part 4: Priority & Impact - Deep Dive: Your Biggest Win',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'What\'s broken today:',
                            answerKey: '3d-growth-system-q-7-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Hours wasted weekly:',
                            answerKey: '3d-growth-system-q-7-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Revenue lost monthly: £',
                            answerKey: '3d-growth-system-q-7-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What success looks like:',
                            answerKey: '3d-growth-system-q-7-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Month 1 impact: £',
                            answerKey: '3d-growth-system-q-7-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Month 6 impact: £',
                            answerKey: '3d-growth-system-q-7-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Year 1 impact: £',
                            answerKey: '3d-growth-system-q-7-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 9,
                    exerciseName: 'Part 5: Making It Happen - Reality Check',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Are competitors doing this?',
                            answerKey: '3d-growth-system-q-8-0',
                            questionType: 'radio',
                            options: [
                                'Yes',
                                'No',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Why haven\'t you done it yet?',
                            answerKey: '3d-growth-system-q-8-1',
                            questionType: 'checkbox',
                            options: [
                                'Didn\'t know it was possible',
                                'No time to implement',
                                'Unclear on ROI',
                                'Technology barriers',
                                'Team resistance'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What\'s the cost of waiting another month? £',
                            answerKey: '3d-growth-system-q-8-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 10,
                    exerciseName: 'Part 5: Making It Happen - Your Readiness',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'When do you want this fixed?',
                            answerKey: '3d-growth-system-q-9-0',
                            questionType: 'radio',
                            options: [
                                'This month - urgent priority',
                                'This quarter - active project',
                                'This year - planning stage',
                                'Just exploring options'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'What would help you most?',
                            answerKey: '3d-growth-system-q-9-1',
                            questionType: 'checkbox',
                            options: [
                                'See exactly how it works',
                                'Understand the ROI clearly',
                                'Get team buy-in',
                                'Start with small pilot',
                                'Full implementation plan'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Preferred next step:',
                            answerKey: '3d-growth-system-q-9-2',
                            questionType: 'radio',
                            options: [
                                'Meeting to discuss',
                                'Not ready yet'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 11,
                    exerciseName: 'Part 5: Making It Happen - Your Commitment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'The ONE opportunity I will pursue:',
                            answerKey: '3d-growth-system-q-10-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Revenue I will capture: £',
                            answerKey: '3d-growth-system-q-10-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'By when:',
                            answerKey: '3d-growth-system-q-10-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Tomorrow I will:',
                            answerKey: '3d-growth-system-q-10-3'
                        }
                    ]
                }
            ]
        }
    },
    'putting-ai-to-work-london-2026': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        },
        '3d-growth-system': {
            tabName: 'The 3D Growth System',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Quick Check: Your Hidden Opportunities',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Which apply to your business? (tick all that apply)',
                            answerKey: '3d-growth-system-q-0-0',
                            questionType: 'checkbox',
                            options: [
                                'Database of "old" contacts not touched in months',
                                'Weekend enquiries wait until Monday for response',
                                'Support team answers same questions repeatedly',
                                'Customer Success Managers too busy to be proactive',
                                'Every customer gets same generic experience',
                                'Discover customer churn after it\'s too late'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Part 1: Revenue Dimension - Lead Response Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Enquiries per month:',
                            answerKey: '3d-growth-system-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: '% of enquiries outside office hours:',
                            answerKey: '3d-growth-system-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current response time to these:',
                            answerKey: '3d-growth-system-q-1-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: '% contacted within 1 hour:',
                            answerKey: '3d-growth-system-q-1-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: '% contacted after 24 hours:',
                            answerKey: '3d-growth-system-q-1-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If you contacted 100% within 5 minutes, how many more would convert?',
                            answerKey: '3d-growth-system-q-1-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Weekend revenue currently lost: £',
                            answerKey: '3d-growth-system-q-1-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Part 1: Revenue Dimension - Database Mining Potential',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Total contacts in database:',
                            answerKey: '3d-growth-system-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Contacted in last 6 months:',
                            answerKey: '3d-growth-system-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Estimated % who might now be ready:',
                            answerKey: '3d-growth-system-q-2-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Hidden revenue in dormant database: £',
                            answerKey: '3d-growth-system-q-2-4'
                        }
                    ]
                },
                {
                    exerciseNumber: 4,
                    exerciseName: 'Part 2: Capacity Dimension - Support Efficiency Audit',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Support tickets per month:',
                            answerKey: '3d-growth-system-q-3-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: '% that are repeat questions:',
                            answerKey: '3d-growth-system-q-3-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Time spent weekly on answering repetitive questions:',
                            answerKey: '3d-growth-system-q-3-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Time spent weekly on manual ticket routing:',
                            answerKey: '3d-growth-system-q-3-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Time spent weekly on writing similar responses:',
                            answerKey: '3d-growth-system-q-3-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Time spent weekly on after-hours coverage:',
                            answerKey: '3d-growth-system-q-3-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Total time that could be redirected:',
                            answerKey: '3d-growth-system-q-3-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 5,
                    exerciseName: 'Part 2: Capacity Dimension - Customer Success Scale',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Customers per Success Manager:',
                            answerKey: '3d-growth-system-q-4-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average upsell value: £',
                            answerKey: '3d-growth-system-q-4-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Customer lifetime value: £',
                            answerKey: '3d-growth-system-q-4-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current monthly churn rate:',
                            answerKey: '3d-growth-system-q-4-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Proactive check-ins per month:',
                            answerKey: '3d-growth-system-q-4-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'If CSMs had 50% more time - Additional customers saved/month:',
                            answerKey: '3d-growth-system-q-4-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If CSMs had 50% more time - Additional upsell conversations:',
                            answerKey: '3d-growth-system-q-4-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Revenue protected/expanded with more capacity: £',
                            answerKey: '3d-growth-system-q-4-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 6,
                    exerciseName: 'Part 3: Experience Dimension - Personalisation Assessment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: '% getting generic experience:',
                            answerKey: '3d-growth-system-q-5-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average products/services per customer:',
                            answerKey: '3d-growth-system-q-5-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Cross-sell conversion rate:',
                            answerKey: '3d-growth-system-q-5-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Could personalisation increase spend per customer?',
                            answerKey: '3d-growth-system-q-5-3',
                            questionType: 'radio',
                            options: [
                                'Definitely (20-40% typical)',
                                'Probably (10-20% typical)',
                                'Possibly (5-10% typical)',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Example for your business: What journey would delight your best customer segment?',
                            answerKey: '3d-growth-system-q-5-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Additional revenue per customer with personalisation: £',
                            answerKey: '3d-growth-system-q-5-5'
                        }
                    ]
                },
                {
                    exerciseNumber: 7,
                    exerciseName: 'Part 4: Priority & Impact - Your Opportunity Matrix',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Rate Weekend response (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Rate Weekend response (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Rate Database reactivation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Rate Database reactivation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Rate Support automation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Rate Support automation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Rate Success scaling (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Rate Success scaling (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-7'
                        },
                        {
                            questionNumber: 8,
                            questionText: 'Rate Personalisation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-8'
                        },
                        {
                            questionNumber: 9,
                            questionText: 'Rate Personalisation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-9'
                        },
                        {
                            questionNumber: 10,
                            questionText: 'Your #1 Opportunity:',
                            answerKey: '3d-growth-system-q-6-10'
                        }
                    ]
                },
                {
                    exerciseNumber: 8,
                    exerciseName: 'Part 4: Priority & Impact - Deep Dive: Your Biggest Win',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'What\'s broken today:',
                            answerKey: '3d-growth-system-q-7-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Hours wasted weekly:',
                            answerKey: '3d-growth-system-q-7-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Revenue lost monthly: £',
                            answerKey: '3d-growth-system-q-7-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What success looks like:',
                            answerKey: '3d-growth-system-q-7-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Month 1 impact: £',
                            answerKey: '3d-growth-system-q-7-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Month 6 impact: £',
                            answerKey: '3d-growth-system-q-7-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Year 1 impact: £',
                            answerKey: '3d-growth-system-q-7-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 9,
                    exerciseName: 'Part 5: Making It Happen - Reality Check',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Are competitors doing this?',
                            answerKey: '3d-growth-system-q-8-0',
                            questionType: 'radio',
                            options: [
                                'Yes',
                                'No',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Why haven\'t you done it yet?',
                            answerKey: '3d-growth-system-q-8-1',
                            questionType: 'checkbox',
                            options: [
                                'Didn\'t know it was possible',
                                'No time to implement',
                                'Unclear on ROI',
                                'Technology barriers',
                                'Team resistance'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What\'s the cost of waiting another month? £',
                            answerKey: '3d-growth-system-q-8-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 10,
                    exerciseName: 'Part 5: Making It Happen - Your Readiness',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'When do you want this fixed?',
                            answerKey: '3d-growth-system-q-9-0',
                            questionType: 'radio',
                            options: [
                                'This month - urgent priority',
                                'This quarter - active project',
                                'This year - planning stage',
                                'Just exploring options'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'What would help you most?',
                            answerKey: '3d-growth-system-q-9-1',
                            questionType: 'checkbox',
                            options: [
                                'See exactly how it works',
                                'Understand the ROI clearly',
                                'Get team buy-in',
                                'Start with small pilot',
                                'Full implementation plan'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Preferred next step:',
                            answerKey: '3d-growth-system-q-9-2',
                            questionType: 'radio',
                            options: [
                                'Meeting to discuss',
                                'Not ready yet'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 11,
                    exerciseName: 'Part 5: Making It Happen - Your Commitment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'The ONE opportunity I will pursue:',
                            answerKey: '3d-growth-system-q-10-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Revenue I will capture: £',
                            answerKey: '3d-growth-system-q-10-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'By when:',
                            answerKey: '3d-growth-system-q-10-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Tomorrow I will:',
                            answerKey: '3d-growth-system-q-10-3'
                        }
                    ]
                }
            ]
        }
    },
    'putting-ai-to-work-manchester-2026': {
        'ai-helpdesk': {
            tabName: 'The 24/7 Department',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Departmental Constraint Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3 departments that could benefit from AI support to scale:',
                            answerKey: 'ai-helpdesk-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Estimate weekly time spent by senior team supporting items that AI could handle:',
                            answerKey: 'ai-helpdesk-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Calculate potential ROI: (Senior person hourly rate × hours worked on support items)',
                            answerKey: 'ai-helpdesk-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Conversation Flow Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Your most common customer or employee inquiry:',
                            answerKey: 'ai-helpdesk-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Design a basic AI conversation flow & resources needed:',
                            answerKey: 'ai-helpdesk-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define information gathering questions:',
                            answerKey: 'ai-helpdesk-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Outline resolution paths and escalation criteria:',
                            answerKey: 'ai-helpdesk-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Human-AI Integration',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 trigger points for human handoff:',
                            answerKey: 'ai-helpdesk-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Create criteria for handoff determination:',
                            answerKey: 'ai-helpdesk-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design knowledge transfer protocol:',
                            answerKey: 'ai-helpdesk-q-2-2'
                        }
                    ]
                }
            ]
        },
        'data-streams': {
            tabName: 'Breaking From The Pack',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Data Stream Inventory',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List key data streams in your organisation:',
                            answerKey: 'data-streams-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify underutilised data streams:',
                            answerKey: 'data-streams-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Select the most valuable data streams for AI enhancement:',
                            answerKey: 'data-streams-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'High-Value Prediction',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one operational area for prediction:',
                            answerKey: 'data-streams-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define the specific prediction needed:',
                            answerKey: 'data-streams-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'List required data sources and current gaps:',
                            answerKey: 'data-streams-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Insight Visualisation',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Choose the reports you want for AI analysed insights:',
                            answerKey: 'data-streams-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'List 3-5 key metrics for decision-making:',
                            answerKey: 'data-streams-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Define update frequency and access permissions:',
                            answerKey: 'data-streams-q-2-2'
                        }
                    ]
                }
            ]
        },
        'ai-first': {
            tabName: 'AI-First Business',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'New Business Possibility Canvas',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify 3 new business possibilities enabled by AI:',
                            answerKey: 'ai-first-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Who are the new customers or underserved segments?',
                            answerKey: 'ai-first-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What unique value propositions would these create?',
                            answerKey: 'ai-first-q-0-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What traditional business constraints would this overcome?',
                            answerKey: 'ai-first-q-0-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Experience Reimagination',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Select one current customer journey:',
                            answerKey: 'ai-first-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Reimagine it with AI as the foundation:',
                            answerKey: 'ai-first-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Map new touchpoints and personalization opportunities:',
                            answerKey: 'ai-first-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Describe how this creates 10x improvement:',
                            answerKey: 'ai-first-q-1-3'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'AI-Native Venture Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Design a new venture built around AI capabilities:',
                            answerKey: 'ai-first-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Core AI technology advantage:',
                            answerKey: 'ai-first-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Data strategy and compounding advantage mechanism:',
                            answerKey: 'ai-first-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Potential disruption to existing business models:',
                            answerKey: 'ai-first-q-2-3'
                        }
                    ]
                }
            ]
        },
        'integrated-ai-os': {
            tabName: 'Connected Agents = Exponential Value',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'AI OS Blueprint',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Map your current departments with highest impact potential for AI transformation:',
                            answerKey: 'integrated-ai-os-q-0-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Identify connection points between different AI agents:',
                            answerKey: 'integrated-ai-os-q-0-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design information flow between human and digital workforce:',
                            answerKey: 'integrated-ai-os-q-0-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Agent Network Design',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'List 3-5 potential AI agents in your organisation:',
                            answerKey: 'integrated-ai-os-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Define how these agents would communicate:',
                            answerKey: 'integrated-ai-os-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Outline the human touchpoints in this network:',
                            answerKey: 'integrated-ai-os-q-1-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Value Amplification Strategy',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Identify how connected agents create more value than isolated ones:',
                            answerKey: 'integrated-ai-os-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Calculate potential efficiency gains from an integrated approach:',
                            answerKey: 'integrated-ai-os-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Design metrics to measure the network effect of your AI OS:',
                            answerKey: 'integrated-ai-os-q-2-2'
                        }
                    ]
                }
            ]
        },
        '3d-growth-system': {
            tabName: 'The 3D Growth System',
            exercises: [
                {
                    exerciseNumber: 1,
                    exerciseName: 'Quick Check: Your Hidden Opportunities',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Which apply to your business? (tick all that apply)',
                            answerKey: '3d-growth-system-q-0-0',
                            questionType: 'checkbox',
                            options: [
                                'Database of "old" contacts not touched in months',
                                'Weekend enquiries wait until Monday for response',
                                'Support team answers same questions repeatedly',
                                'Customer Success Managers too busy to be proactive',
                                'Every customer gets same generic experience',
                                'Discover customer churn after it\'s too late'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 2,
                    exerciseName: 'Part 1: Revenue Dimension - Lead Response Analysis',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Enquiries per month:',
                            answerKey: '3d-growth-system-q-1-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-1-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: '% of enquiries outside office hours:',
                            answerKey: '3d-growth-system-q-1-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current response time to these:',
                            answerKey: '3d-growth-system-q-1-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: '% contacted within 1 hour:',
                            answerKey: '3d-growth-system-q-1-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: '% contacted after 24 hours:',
                            answerKey: '3d-growth-system-q-1-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If you contacted 100% within 5 minutes, how many more would convert?',
                            answerKey: '3d-growth-system-q-1-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Weekend revenue currently lost: £',
                            answerKey: '3d-growth-system-q-1-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 3,
                    exerciseName: 'Part 1: Revenue Dimension - Database Mining Potential',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Total contacts in database:',
                            answerKey: '3d-growth-system-q-2-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average deal value: £',
                            answerKey: '3d-growth-system-q-2-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Contacted in last 6 months:',
                            answerKey: '3d-growth-system-q-2-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Estimated % who might now be ready:',
                            answerKey: '3d-growth-system-q-2-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Hidden revenue in dormant database: £',
                            answerKey: '3d-growth-system-q-2-4'
                        }
                    ]
                },
                {
                    exerciseNumber: 4,
                    exerciseName: 'Part 2: Capacity Dimension - Support Efficiency Audit',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Support tickets per month:',
                            answerKey: '3d-growth-system-q-3-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: '% that are repeat questions:',
                            answerKey: '3d-growth-system-q-3-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Time spent weekly on answering repetitive questions:',
                            answerKey: '3d-growth-system-q-3-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Time spent weekly on manual ticket routing:',
                            answerKey: '3d-growth-system-q-3-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Time spent weekly on writing similar responses:',
                            answerKey: '3d-growth-system-q-3-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Time spent weekly on after-hours coverage:',
                            answerKey: '3d-growth-system-q-3-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Total time that could be redirected:',
                            answerKey: '3d-growth-system-q-3-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 5,
                    exerciseName: 'Part 2: Capacity Dimension - Customer Success Scale',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Customers per Success Manager:',
                            answerKey: '3d-growth-system-q-4-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average upsell value: £',
                            answerKey: '3d-growth-system-q-4-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Customer lifetime value: £',
                            answerKey: '3d-growth-system-q-4-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Current monthly churn rate:',
                            answerKey: '3d-growth-system-q-4-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Proactive check-ins per month:',
                            answerKey: '3d-growth-system-q-4-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'If CSMs had 50% more time - Additional customers saved/month:',
                            answerKey: '3d-growth-system-q-4-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'If CSMs had 50% more time - Additional upsell conversations:',
                            answerKey: '3d-growth-system-q-4-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Revenue protected/expanded with more capacity: £',
                            answerKey: '3d-growth-system-q-4-7'
                        }
                    ]
                },
                {
                    exerciseNumber: 6,
                    exerciseName: 'Part 3: Experience Dimension - Personalisation Assessment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: '% getting generic experience:',
                            answerKey: '3d-growth-system-q-5-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Average products/services per customer:',
                            answerKey: '3d-growth-system-q-5-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Cross-sell conversion rate:',
                            answerKey: '3d-growth-system-q-5-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Could personalisation increase spend per customer?',
                            answerKey: '3d-growth-system-q-5-3',
                            questionType: 'radio',
                            options: [
                                'Definitely (20-40% typical)',
                                'Probably (10-20% typical)',
                                'Possibly (5-10% typical)',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Example for your business: What journey would delight your best customer segment?',
                            answerKey: '3d-growth-system-q-5-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Additional revenue per customer with personalisation: £',
                            answerKey: '3d-growth-system-q-5-5'
                        }
                    ]
                },
                {
                    exerciseNumber: 7,
                    exerciseName: 'Part 4: Priority & Impact - Your Opportunity Matrix',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Rate Weekend response (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Rate Weekend response (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Rate Database reactivation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Rate Database reactivation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Rate Support automation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Rate Support automation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Rate Success scaling (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-6'
                        },
                        {
                            questionNumber: 7,
                            questionText: 'Rate Success scaling (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-7'
                        },
                        {
                            questionNumber: 8,
                            questionText: 'Rate Personalisation (Impact 1-10):',
                            answerKey: '3d-growth-system-q-6-8'
                        },
                        {
                            questionNumber: 9,
                            questionText: 'Rate Personalisation (Speed 1-10):',
                            answerKey: '3d-growth-system-q-6-9'
                        },
                        {
                            questionNumber: 10,
                            questionText: 'Your #1 Opportunity:',
                            answerKey: '3d-growth-system-q-6-10'
                        }
                    ]
                },
                {
                    exerciseNumber: 8,
                    exerciseName: 'Part 4: Priority & Impact - Deep Dive: Your Biggest Win',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'What\'s broken today:',
                            answerKey: '3d-growth-system-q-7-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Hours wasted weekly:',
                            answerKey: '3d-growth-system-q-7-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Revenue lost monthly: £',
                            answerKey: '3d-growth-system-q-7-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'What success looks like:',
                            answerKey: '3d-growth-system-q-7-3'
                        },
                        {
                            questionNumber: 4,
                            questionText: 'Month 1 impact: £',
                            answerKey: '3d-growth-system-q-7-4'
                        },
                        {
                            questionNumber: 5,
                            questionText: 'Month 6 impact: £',
                            answerKey: '3d-growth-system-q-7-5'
                        },
                        {
                            questionNumber: 6,
                            questionText: 'Year 1 impact: £',
                            answerKey: '3d-growth-system-q-7-6'
                        }
                    ]
                },
                {
                    exerciseNumber: 9,
                    exerciseName: 'Part 5: Making It Happen - Reality Check',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'Are competitors doing this?',
                            answerKey: '3d-growth-system-q-8-0',
                            questionType: 'radio',
                            options: [
                                'Yes',
                                'No',
                                'Not sure'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Why haven\'t you done it yet?',
                            answerKey: '3d-growth-system-q-8-1',
                            questionType: 'checkbox',
                            options: [
                                'Didn\'t know it was possible',
                                'No time to implement',
                                'Unclear on ROI',
                                'Technology barriers',
                                'Team resistance'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'What\'s the cost of waiting another month? £',
                            answerKey: '3d-growth-system-q-8-2'
                        }
                    ]
                },
                {
                    exerciseNumber: 10,
                    exerciseName: 'Part 5: Making It Happen - Your Readiness',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'When do you want this fixed?',
                            answerKey: '3d-growth-system-q-9-0',
                            questionType: 'radio',
                            options: [
                                'This month - urgent priority',
                                'This quarter - active project',
                                'This year - planning stage',
                                'Just exploring options'
                            ]
                        },
                        {
                            questionNumber: 1,
                            questionText: 'What would help you most?',
                            answerKey: '3d-growth-system-q-9-1',
                            questionType: 'checkbox',
                            options: [
                                'See exactly how it works',
                                'Understand the ROI clearly',
                                'Get team buy-in',
                                'Start with small pilot',
                                'Full implementation plan'
                            ]
                        },
                        {
                            questionNumber: 2,
                            questionText: 'Preferred next step:',
                            answerKey: '3d-growth-system-q-9-2',
                            questionType: 'radio',
                            options: [
                                'Meeting to discuss',
                                'Not ready yet'
                            ]
                        }
                    ]
                },
                {
                    exerciseNumber: 11,
                    exerciseName: 'Part 5: Making It Happen - Your Commitment',
                    questions: [
                        {
                            questionNumber: 0,
                            questionText: 'The ONE opportunity I will pursue:',
                            answerKey: '3d-growth-system-q-10-0'
                        },
                        {
                            questionNumber: 1,
                            questionText: 'Revenue I will capture: £',
                            answerKey: '3d-growth-system-q-10-1'
                        },
                        {
                            questionNumber: 2,
                            questionText: 'By when:',
                            answerKey: '3d-growth-system-q-10-2'
                        },
                        {
                            questionNumber: 3,
                            questionText: 'Tomorrow I will:',
                            answerKey: '3d-growth-system-q-10-3'
                        }
                    ]
                }
            ]
        }
    },
}; 